import { render, staticRenderFns } from "./video-draw-polygon.vue?vue&type=template&id=e3223b9e&scoped=true&"
import script from "./video-draw-polygon.vue?vue&type=script&lang=js&"
export * from "./video-draw-polygon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3223b9e",
  null
  
)

export default component.exports